/**
 * <ResponsiveImage> — outputs an <img srcset="..." sizes="..."> so phones
 * download the 400w variant (~15 KB) instead of the 1800w original (~240 KB).
 *
 * Convention: for a src like `/lookbook/crossfit.webp`, the build script
 * generates `/lookbook/crossfit-400.webp` + `/lookbook/crossfit-800.webp`.
 * If `srcset={false}` is passed, falls back to a plain <img>.
 *
 * Usage:
 *   <ResponsiveImage src="/lookbook/crossfit.webp" alt="CrossFit" sizes="(max-width:768px) 100vw, 800px" />
 */
export default function ResponsiveImage({
    src,
    alt = "",
    sizes = "(max-width: 480px) 400px, (max-width: 1024px) 800px, 100vw",
    className,
    eager = false,
    fetchPriority,
    style,
    ...rest
}) {
    if (!src) return null;
    const isWebp = /\.webp(\?|$)/i.test(src);
    const dot = src.lastIndexOf(".");
    const base = src.substring(0, dot);
    const ext = src.substring(dot);

    const srcSet = isWebp
        ? `${base}-400${ext} 400w, ${base}-800${ext} 800w, ${src} 1800w`
        : undefined;

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            style={style}
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            fetchPriority={fetchPriority}
            srcSet={srcSet}
            sizes={srcSet ? sizes : undefined}
            {...rest}
        />
    );
}
